// The ticket shop's registration/checkout flow can be embedded in an iframe
// on an external site (e.g. a WordPress page for an event like the
// Lichtjestour). Payment providers (Mollie, Pay.nl) send
// X-Frame-Options / Content-Security-Policy: frame-ancestors headers on
// their checkout pages -- standard clickjacking protection for a payment
// page -- which makes the browser silently refuse to load their checkout
// inside our iframe. There is no error, no console warning a user would
// notice: the screen just stays blank forever.
//
// Every redirect to an external payment checkout URL must therefore navigate
// the TOP-LEVEL browsing context, not whatever frame the checkout form
// itself happens to be running inside. `win` is injectable so this can be
// unit-tested without depending on jsdom's (unsupported) real navigation.
export function navigateTopLevel(url, win = typeof window !== "undefined" ? window : undefined) {
  if (!url || !win) return;

  try {
    const top = win.top;
    if (top && top.location) {
      top.location.href = url;
      return;
    }
  } catch {
    // Reading/writing window.top threw -- a cross-origin ancestor without
    // "allow-top-navigation" can make window.top inaccessible. Fall through.
  }

  try {
    // "_top" targets the top-level browsing context by name, which can work
    // even when window.top itself can't be read or written directly.
    const opened = win.open(url, "_top");
    if (opened) return;
  } catch {
    // window.open blocked (popup blocker) or unavailable -- fall through.
  }

  // Last resort: navigate whatever frame we actually have, so the user is
  // never left on a permanently blank screen even in a browsing context
  // this function couldn't escape.
  win.location.href = url;
}
